import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  position: relative;\n\n  &::after {\n    background-color: ", ";\n    border-radius: 50%;\n    content: '';\n    display: ", ";\n    left: 50%;\n    opacity: 0;\n    padding-bottom: 7.7%;\n    pointer-events: none;\n    position: absolute;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0) scale(10.2, 10.2);\n    transition: ", ";\n    width: 7.7%;\n  }\n\n  &:focus {\n    ", ";\n\n    outline: none;\n  }\n\n  &:active {\n    &::after {\n      opacity: 0.25;\n      transform: translate3d(-50%, -50%, 0) scale(0, 0);\n      transition: 0s;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &::after {\n    opacity: 0.29;\n    transform: translate3d(-50%, -50%, 0) scale(", ", ", ");\n    transition: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { color } from '@scp/ui-shared/theme/variables';
import { RippleConsumer } from './RippleContext';
var STYLE_PROPS_TO_OMIT = ['rippleColor'];
var FOCUS_TRANSITION = 'transform 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) 0s';
var CLICK_TRANSITION = 'transform 0.5s, opacity 1s';
export var getFocusedStyle = function getFocusedStyle() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 11.6;
  return css(_templateObject(), scale, scale, FOCUS_TRANSITION);
};
var ElementWithRipple = styled.span(_templateObject2(), function (props) {
  return props.rippleColor;
}, function (props) {
  return props.disabled ? 'none' : 'block';
}, CLICK_TRANSITION, function (props) {
  return props.navigatingByKeyboard && getFocusedStyle();
});
export var withRippleEffect = function withRippleEffect(WrappedComponnet) {
  var rippleColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : color.ripple;
  var escapeKeyboardNavProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var renderAs = withoutProps(WrappedComponnet, escapeKeyboardNavProp ? [].concat(STYLE_PROPS_TO_OMIT, ['navigatingByKeyboard']) : STYLE_PROPS_TO_OMIT);
  return React.forwardRef(function (props, ref) {
    return React.createElement(RippleConsumer, null, function (navigatingByKeyboard) {
      return React.createElement(ElementWithRipple, Object.assign({
        ref: ref,
        rippleColor: rippleColor
      }, props, {
        navigatingByKeyboard: navigatingByKeyboard,
        as: renderAs
      }));
    });
  });
};